// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3CEAW","colMaxWidth":"Table_colMaxWidth__1BmP4"};